import css from 'styled-jsx/css';

const styles = css.global`.main_button{height:2.9473684211rem;padding:0 2.1052631579rem;background:var(--primary-cyan);text-transform:uppercase;font-weight:bold;color:var(--primary-green);font-size:1.2631578947rem;box-shadow:0 3px 6px rgba(0,0,0,.16);display:flex;align-items:center;justify-content:center;transition:filter .2s ease-in-out;white-space:nowrap}.main_button:hover{filter:brightness(1.2)}`;

export default styles;